<div *ngIf="observable_loading$ | async" style="height: 100vh; width:100%; align-items: center; justify-content: center; display: flex; z-index: 100;">
     <mat-spinner></mat-spinner>
     <h1>Si prega di attendere, caricamento in corso....</h1>
</div>
<div
leaflet
[leafletOptions]="options"
(leafletMapReady)="onMapReady($event)"
(leafletMapZoomEnd)="onMapZoomEnd($event)"
id='mapM2'
(addFilter)="addFilter.emit()"
[class.map-hidden]="observable_loading$ | async"
>
     <div *ngIf="!opened" class="filter-table"><app-map-gps-list></app-map-gps-list></div>
     <div class="filter-button" fxLayout="row">
          <button class="button" mat-button (click)=toggleDisplayDiv() type="button" [class.button--enabled]="!opened">
               <span class="fa fa-bars fa-2x" >
               </span>
          </button>
          <button class="button" (click)="openMapFilters()" type="button">
               <span class="fa fa-filter fa-2x"  >
               </span>
          </button>
     </div>
     <div class="gps-info" *ngIf="data" >
          <button (click)="closeInfo($event)" class="info-button"><b>x</b></button>
          <h1>Veicolo: {{ data.licenseplate }} {{ data.brand }} {{ data.type_item?.description}}, Gruppo: {{data.data_collector_item?.group_item?.name}}</h1>
     </div>
</div>